import { render, staticRenderFns } from "./ResultIrc.vue?vue&type=template&id=e3487404&scoped=true&"
import script from "./ResultIrc.vue?vue&type=script&lang=js&"
export * from "./ResultIrc.vue?vue&type=script&lang=js&"
import style0 from "./ResultIrc.vue?vue&type=style&index=0&id=e3487404&scoped=true&lang=css&"
import style1 from "./ResultIrc.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3487404",
  null
  
)

export default component.exports